var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "img-upload" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                _vm.$refs.headPhoto.$el
                                  .querySelector("input")
                                  .click()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-camera",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _c("el-upload", {
                              ref: "headPhoto",
                              staticClass: "uploadFile img",
                              staticStyle: {
                                width: "0px",
                                height: "0px",
                                overflow: "hidden",
                              },
                              attrs: {
                                action: "",
                                accept: ".jpg,.jpeg,.png",
                                "auto-upload": false,
                                "show-file-list": false,
                                "on-change": _vm.uploadHeadPhoto,
                                limit: 1,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.headPhotoBase64
                          ? _c("div", {
                              staticClass: "imagePreview",
                              style: {
                                "background-image":
                                  "url(" + _vm.headPhotoBase64 + ")",
                              },
                            })
                          : _c("div", { staticClass: "imagePreview" }),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 中文姓名 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Chinese name")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.baseInfo.Name,
                                                expression: "baseInfo.Name",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "50",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.baseInfo.Name,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "Name",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 性別 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Gender")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.baseInfo.Sex,
                                                  expression: "baseInfo.Sex",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: 0,
                                                checked: _vm._q(
                                                  _vm.baseInfo.Sex,
                                                  0
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "Sex",
                                                    0
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("男 (Male)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.baseInfo.Sex,
                                                  expression: "baseInfo.Sex",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: 1,
                                                checked: _vm._q(
                                                  _vm.baseInfo.Sex,
                                                  1
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "Sex",
                                                    1
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("女 (Female)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 應徵工作班別 (可複選) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " Apply work shift (Can select many) "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value:
                                                  _vm.baseInfo.WorkShiftTypes,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "WorkShiftTypes",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.WorkShiftTypes",
                                              },
                                            },
                                            [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  label:
                                                    "D班 shift（07：00~19：05）",
                                                },
                                              }),
                                              _c("el-checkbox", {
                                                attrs: {
                                                  label:
                                                    "N班 shift（19：00~07：05）",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { name: "生日", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 生日 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Date of birth")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("el-date-picker", {
                                            staticClass: "w-100",
                                            attrs: {
                                              type: "date",
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options": {
                                                disabledDate:
                                                  _vm.$common
                                                    .disabledDateAfterToday,
                                              },
                                              placeholder: "YYYY-MM-DD",
                                            },
                                            model: {
                                              value: _vm.baseInfo.BirthDay,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "BirthDay",
                                                  $$v
                                                )
                                              },
                                              expression: "baseInfo.BirthDay",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { name: "國籍", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 國籍 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Nationality")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請選擇",
                                              },
                                              model: {
                                                value:
                                                  _vm.baseInfo.NationalityGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "NationalityGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.NationalityGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.countryOptions,
                                              function (country) {
                                                return _c("el-option", {
                                                  key: country.Guid,
                                                  attrs: {
                                                    label: country.Name,
                                                    value: country.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm.baseInfo.NationalityGuid !==
                    "99999999-9999-9999-9999-999999999999"
                      ? [
                          _c(
                            "div",
                            {
                              class:
                                _vm.baseInfo.ForeignerReason === 3
                                  ? "col-md-6"
                                  : "col-md-12",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "field" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "外籍在台原因",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "field-title" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      style: {
                                                        color: _vm.fontColor,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(" 外籍在台原因 "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "en-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Reason why foreigner in Taiwan"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "field-value" },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        placeholder: "請選擇",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.baseInfo
                                                            .ForeignerReason,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.baseInfo,
                                                            "ForeignerReason",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "baseInfo.ForeignerReason",
                                                      },
                                                    },
                                                    [
                                                      _c("el-option", {
                                                        attrs: {
                                                          label:
                                                            "依親在台 Relative in Taiwan",
                                                          value: 0,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        attrs: {
                                                          label:
                                                            "工作在台 Work in Taiwan",
                                                          value: 1,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        attrs: {
                                                          label:
                                                            "就學在台 Education at Taiwan",
                                                          value: 2,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        attrs: {
                                                          label:
                                                            "其他原因在台 Other reason at Taiwan",
                                                          value: 3,
                                                        },
                                                      }),
                                                      _c("el-option", {
                                                        attrs: {
                                                          label:
                                                            "仲介選工 Manpower agency select workers",
                                                          value: 4,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm.baseInfo.ForeignerReason === 3
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.baseInfo.ForeignerReason === 3
                                      ? "col-md-6"
                                      : "col-md-6",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "field" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "備註",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-title",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          style: {
                                                            color:
                                                              _vm.fontColor,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(" 備註 "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "en-text",
                                                            },
                                                            [_vm._v("Remark")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-value",
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticClass: "w-100",
                                                        model: {
                                                          value:
                                                            _vm.baseInfo
                                                              .ForeignerReasonDesc,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.baseInfo,
                                                              "ForeignerReasonDesc",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "baseInfo.ForeignerReasonDesc",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 身分證字號/護照號碼 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("ID no./Passport no."),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.IdNo,
                                expression: "baseInfo.IdNo",
                              },
                            ],
                            attrs: {
                              type: "text",
                              maxlength: "20",
                              autocomplete: "off",
                              readonly: "",
                            },
                            domProps: { value: _vm.baseInfo.IdNo },
                            on: {
                              focus: function ($event) {
                                return _vm.$common.removeReadonly($event)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.baseInfo,
                                  "IdNo",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { name: "手機", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 手機 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Cellphone")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.baseInfo.MobilePhone,
                                                expression:
                                                  "baseInfo.MobilePhone",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "50",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.baseInfo.MobilePhone,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "MobilePhone",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { name: "E-mail", rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [_vm._v(" E-mail ")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.baseInfo.Email,
                                                expression: "baseInfo.Email",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "50",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.baseInfo.Email,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "Email",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 家用電話(區域碼-號碼) "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Family Phone"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.Phone,
                                expression: "baseInfo.Phone",
                              },
                            ],
                            attrs: {
                              type: "text",
                              maxlength: "50",
                              autocomplete: "off",
                              readonly: "",
                            },
                            domProps: { value: _vm.baseInfo.Phone },
                            on: {
                              focus: function ($event) {
                                return _vm.$common.removeReadonly($event)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.baseInfo,
                                  "Phone",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 身高(cm) "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Height(cm)"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.Height,
                                expression: "baseInfo.Height",
                              },
                            ],
                            attrs: { type: "number", min: "0", max: "999.9" },
                            domProps: { value: _vm.baseInfo.Height },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.baseInfo,
                                    "Height",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.baseInfo.Height =
                                    _vm.$common.oneDecimalPlace(
                                      _vm.baseInfo.Height
                                    )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 體重(kg) "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Weight(kg)"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.Weight,
                                expression: "baseInfo.Weight",
                              },
                            ],
                            attrs: { type: "number", min: "0", max: "999.9" },
                            domProps: { value: _vm.baseInfo.Weight },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.baseInfo,
                                    "Weight",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.baseInfo.Weight =
                                    _vm.$common.oneDecimalPlace(
                                      _vm.baseInfo.Weight
                                    )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("div", { staticClass: "field-title" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", { style: { color: _vm.fontColor } }, [
                              _vm._v(" 配合加班 "),
                              _c("span", { staticClass: "en-text" }, [
                                _vm._v("Cooperate with overtime"),
                              ]),
                            ]),
                          ]),
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.baseInfo.CanOverTime,
                                                  expression:
                                                    "baseInfo.CanOverTime",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.baseInfo.CanOverTime,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "CanOverTime",
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.baseInfo.CanOverTime,
                                                  expression:
                                                    "baseInfo.CanOverTime",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.baseInfo.CanOverTime,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "CanOverTime",
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              rules: {
                                required: !_vm.baseInfo.CanOverTime
                                  ? true
                                  : false,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          !_vm.baseInfo.CanOverTime
                                            ? _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 原因說明 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Reason")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo.CanOverTimeDesc,
                                                expression:
                                                  "baseInfo.CanOverTimeDesc",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo.CanOverTimeDesc,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "CanOverTimeDesc",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("div", { staticClass: "field-title" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", { style: { color: _vm.fontColor } }, [
                              _vm._v(" 配合輪班 "),
                              _c("span", { staticClass: "en-text" }, [
                                _vm._v("Cooperate with shift rotation"),
                              ]),
                            ]),
                          ]),
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.baseInfo.CanShiftWork,
                                                  expression:
                                                    "baseInfo.CanShiftWork",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.baseInfo.CanShiftWork,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "CanShiftWork",
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.baseInfo.CanShiftWork,
                                                  expression:
                                                    "baseInfo.CanShiftWork",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.baseInfo.CanShiftWork,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "CanShiftWork",
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              rules: {
                                required: !_vm.baseInfo.CanShiftWork
                                  ? true
                                  : false,
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          !_vm.baseInfo.CanShiftWork
                                            ? _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 原因說明 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Reason")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo.CanShiftWorkDesc,
                                                expression:
                                                  "baseInfo.CanShiftWorkDesc",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo.CanShiftWorkDesc,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "CanShiftWorkDesc",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 領有身心障礙手冊 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v(" Do you have a disability booklet "),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-radio" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.baseInfo.HasDisabilityCard,
                                  expression: "baseInfo.HasDisabilityCard",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: true,
                                checked: _vm._q(
                                  _vm.baseInfo.HasDisabilityCard,
                                  true
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.baseInfo,
                                    "HasDisabilityCard",
                                    true
                                  )
                                },
                              },
                            }),
                            _c("span", [_vm._v("是 (Yes)")]),
                          ]),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.baseInfo.HasDisabilityCard,
                                  expression: "baseInfo.HasDisabilityCard",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: false,
                                checked: _vm._q(
                                  _vm.baseInfo.HasDisabilityCard,
                                  false
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.baseInfo,
                                    "HasDisabilityCard",
                                    false
                                  )
                                },
                              },
                            }),
                            _c("span", [_vm._v("否 (No)")]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm.baseInfo.HasDisabilityCard
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "field-title" }, [
                              _c("span", { style: { color: _vm.fontColor } }, [
                                _vm._v(" 身心障礙手冊-說明 "),
                                _c("span", { staticClass: "en-text" }, [
                                  _vm._v(" Disability Memo "),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "field-value" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.baseInfo.HasDisabilityCardDesc,
                                    expression:
                                      "baseInfo.HasDisabilityCardDesc",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  maxlength: "200",
                                  autocomplete: "off",
                                  readonly: "",
                                },
                                domProps: {
                                  value: _vm.baseInfo.HasDisabilityCardDesc,
                                },
                                on: {
                                  focus: function ($event) {
                                    return _vm.$common.removeReadonly($event)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.baseInfo,
                                      "HasDisabilityCardDesc",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        class: _vm.baseInfo.HasDisabilityCard
                          ? "col-md-3"
                          : "col-md-6",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field" },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "field-title" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                style: { color: _vm.fontColor },
                                              },
                                              [
                                                _vm._v(" 住處 "),
                                                _c(
                                                  "span",
                                                  { staticClass: "en-text" },
                                                  [_vm._v("Residence")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "field-value" },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "w-100",
                                                attrs: {
                                                  placeholder: "請選擇",
                                                },
                                                model: {
                                                  value:
                                                    _vm.baseInfo.ResidenceType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.baseInfo,
                                                      "ResidenceType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "baseInfo.ResidenceType",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "住家裡 (Own house)",
                                                    value: 0,
                                                  },
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label:
                                                      "親友提供 (Relative/Friend)",
                                                    value: 1,
                                                  },
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "在外租屋 (Rent)",
                                                    value: 2,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        errors[0]
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(errors[0]) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        class: _vm.baseInfo.HasDisabilityCard
                          ? "col-md-3"
                          : "col-md-6",
                      },
                      [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-title" }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", { style: { color: _vm.fontColor } }, [
                              _vm._v(" 出勤方式 "),
                              _c("span", { staticClass: "en-text" }, [
                                _vm._v("Method of transport"),
                              ]),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "field-value" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-100",
                                  attrs: { placeholder: "請選擇" },
                                  model: {
                                    value: _vm.baseInfo.CommutingType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.baseInfo,
                                        "CommutingType",
                                        $$v
                                      )
                                    },
                                    expression: "baseInfo.CommutingType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "步行 (walk)", value: 0 },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "機車 (scooter)",
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "汽車 (car)", value: 2 },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "腳踏車 (bicycle)",
                                      value: 3,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "大眾運輸 (public transportation)",
                                      value: 4,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required|numeric" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 通勤時間(分鐘) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " Commuting time (minutes)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo.CommutingMinutes,
                                                expression:
                                                  "baseInfo.CommutingMinutes",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              max: "9999",
                                              step: "1",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo.CommutingMinutes,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "CommutingMinutes",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        class:
                          _vm.baseInfo.VisualAcuity === 999
                            ? "col-md-3"
                            : "col-md-6",
                      },
                      [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-title" }, [
                            _c("span", { style: { color: _vm.fontColor } }, [
                              _vm._v(" 視力 "),
                              _c("span", { staticClass: "en-text" }, [
                                _vm._v("Eyesight"),
                              ]),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "field-value" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-100",
                                  attrs: { placeholder: "請選擇" },
                                  model: {
                                    value: _vm.baseInfo.VisualAcuity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.baseInfo,
                                        "VisualAcuity",
                                        $$v
                                      )
                                    },
                                    expression: "baseInfo.VisualAcuity",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "正常 (Normal)", value: 0 },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "雷射矯正 (Laser correction)",
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "近視 (Near sighted)",
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "遠視 (Far sighted)",
                                      value: 3,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "其他 (Other)",
                                      value: 999,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm.baseInfo.VisualAcuity === 999
                      ? _c(
                          "div",
                          {
                            class:
                              _vm.baseInfo.VisualAcuity === 999
                                ? "col-md-3"
                                : "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 視力(說明) "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Eyesight Description"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.baseInfo.VisualAcuityDesc,
                                      expression: "baseInfo.VisualAcuityDesc",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    maxlength: "50",
                                    autocomplete: "off",
                                    readonly: "",
                                  },
                                  domProps: {
                                    value: _vm.baseInfo.VisualAcuityDesc,
                                  },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.$common.removeReadonly($event)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.baseInfo,
                                        "VisualAcuityDesc",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 左眼度數 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Left eye nearsighted"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.SPHLeft,
                                expression: "baseInfo.SPHLeft",
                              },
                            ],
                            attrs: {
                              type: "number",
                              min: "0",
                              max: "9999",
                              step: "1",
                            },
                            domProps: { value: _vm.baseInfo.SPHLeft },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.baseInfo,
                                    "SPHLeft",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.baseInfo.SPHLeft =
                                    _vm.$common.positiveIntPlaces(
                                      _vm.baseInfo.SPHLeft
                                    )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 右眼度數 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Right eye nearsighted"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.SPHRight,
                                expression: "baseInfo.SPHRight",
                              },
                            ],
                            attrs: {
                              type: "number",
                              min: "0",
                              max: "9999",
                              step: "1",
                            },
                            domProps: { value: _vm.baseInfo.SPHRight },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.baseInfo,
                                    "SPHRight",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.baseInfo.SPHRight =
                                    _vm.$common.positiveIntPlaces(
                                      _vm.baseInfo.SPHRight
                                    )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 是否有散光 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Do you have astigmatism"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-radio" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.baseInfo.HasAstigmatic,
                                  expression: "baseInfo.HasAstigmatic",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: true,
                                checked: _vm._q(
                                  _vm.baseInfo.HasAstigmatic,
                                  true
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.baseInfo,
                                    "HasAstigmatic",
                                    true
                                  )
                                },
                              },
                            }),
                            _c("span", [_vm._v("是 (Yes)")]),
                          ]),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.baseInfo.HasAstigmatic,
                                  expression: "baseInfo.HasAstigmatic",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: false,
                                checked: _vm._q(
                                  _vm.baseInfo.HasAstigmatic,
                                  false
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.baseInfo,
                                    "HasAstigmatic",
                                    false
                                  )
                                },
                              },
                            }),
                            _c("span", [_vm._v("否 (No)")]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 左眼散光度數 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Left eye astigmatism"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.CYLLeft,
                                expression: "baseInfo.CYLLeft",
                              },
                            ],
                            attrs: {
                              type: "number",
                              min: "0",
                              max: "9999",
                              step: "1",
                            },
                            domProps: { value: _vm.baseInfo.CYLLeft },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.baseInfo,
                                    "CYLLeft",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.baseInfo.CYLLeft =
                                    _vm.$common.positiveIntPlaces(
                                      _vm.baseInfo.CYLLeft
                                    )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(" 右眼散光度數 "),
                            _c("span", { staticClass: "en-text" }, [
                              _vm._v("Right eye astigmatism"),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.baseInfo.CYLRight,
                                expression: "baseInfo.CYLRight",
                              },
                            ],
                            attrs: {
                              type: "number",
                              min: "0",
                              max: "9999",
                              step: "1",
                            },
                            domProps: { value: _vm.baseInfo.CYLRight },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.baseInfo,
                                    "CYLRight",
                                    $event.target.value
                                  )
                                },
                                function ($event) {
                                  _vm.baseInfo.CYLRight =
                                    _vm.$common.positiveIntPlaces(
                                      _vm.baseInfo.CYLRight
                                    )
                                },
                              ],
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 通訊地址(縣市) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Mailing address(City)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請選擇",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeCity(
                                                    "ContactCountyGuid"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.baseInfo
                                                    .ContactCountyGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "ContactCountyGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.ContactCountyGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.cityOptions,
                                              function (city) {
                                                return _c("el-option", {
                                                  key: city.Guid,
                                                  attrs: {
                                                    label: city.Name,
                                                    value: city.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 通訊地址(區) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Mailing address(District)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請先選擇縣市",
                                              },
                                              model: {
                                                value:
                                                  _vm.baseInfo
                                                    .ContactDistrictGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "ContactDistrictGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.ContactDistrictGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.contactDistrictOptions,
                                              function (district) {
                                                return _c("el-option", {
                                                  key: district.Guid,
                                                  attrs: {
                                                    label: district.Name,
                                                    value: district.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              rules:
                                _vm.source === "personnelInformation"
                                  ? "required"
                                  : null,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm.source ===
                                              "personnelInformation"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" 通訊地址(村里) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Mailing address(Village)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo.ContactVillage,
                                                expression:
                                                  "baseInfo.ContactVillage",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo.ContactVillage,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "ContactVillage",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 通訊地址 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Mailing address")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo.ContactAddress,
                                                expression:
                                                  "baseInfo.ContactAddress",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo.ContactAddress,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "ContactAddress",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 戶籍地址(縣市) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Household address (City)"
                                                  ),
                                                ]
                                              ),
                                              _c("br"),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.householdSameAddress,
                                                    expression:
                                                      "householdSameAddress",
                                                  },
                                                ],
                                                staticStyle: {
                                                  "margin-right": "2px",
                                                },
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.householdSameAddress
                                                  )
                                                    ? _vm._i(
                                                        _vm.householdSameAddress,
                                                        null
                                                      ) > -1
                                                    : _vm.householdSameAddress,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.householdSameAddress,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.householdSameAddress =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.householdSameAddress =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.householdSameAddress =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" 同通訊地址 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Same as mailing address"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請先選擇縣市",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeCity(
                                                    "CountyGuid"
                                                  )
                                                },
                                              },
                                              model: {
                                                value: _vm.baseInfo.CountyGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "CountyGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.CountyGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.cityOptions,
                                              function (city) {
                                                return _c("el-option", {
                                                  key: city.Guid,
                                                  attrs: {
                                                    label: city.Name,
                                                    value: city.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 戶籍地址(區)"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Household address(District)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請先選擇縣市",
                                              },
                                              model: {
                                                value:
                                                  _vm.baseInfo.DistrictGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "DistrictGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.DistrictGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.householdDistrictOptions,
                                              function (district) {
                                                return _c("el-option", {
                                                  key: district.Guid,
                                                  attrs: {
                                                    label: district.Name,
                                                    value: district.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              rules:
                                _vm.source === "personnelInformation"
                                  ? "required"
                                  : null,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm.source ===
                                              "personnelInformation"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" 戶籍地址(村里)"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Household address(Village)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.baseInfo.Village,
                                                expression: "baseInfo.Village",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.baseInfo.Village,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "Village",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 戶籍地址"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Household address")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.baseInfo.Address,
                                                expression: "baseInfo.Address",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.baseInfo.Address,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "Address",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 緊急聯絡人姓名"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Emergency contact name"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo.EmergencyContact,
                                                expression:
                                                  "baseInfo.EmergencyContact",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "50",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo.EmergencyContact,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "EmergencyContact",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 關係"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Relationship")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo
                                                    .EmergencyContactRelationship,
                                                expression:
                                                  "baseInfo.EmergencyContactRelationship",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "50",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo
                                                  .EmergencyContactRelationship,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "EmergencyContactRelationship",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(" 緊急聯絡人電話(手機) "),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " Emergency contact person phone no.(cell phone) "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo
                                                    .EmergencyContactPhone,
                                                expression:
                                                  "baseInfo.EmergencyContactPhone",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "50",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo
                                                  .EmergencyContactPhone,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "EmergencyContactPhone",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 聯絡人地址(縣市) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Contact address(City)"
                                                  ),
                                                ]
                                              ),
                                              _c("br"),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.contactSameAddress,
                                                    expression:
                                                      "contactSameAddress",
                                                  },
                                                ],
                                                staticStyle: {
                                                  "margin-right": "2px",
                                                },
                                                attrs: {
                                                  type: "checkbox",
                                                  disabled:
                                                    _vm.contactSameHousehold,
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.contactSameAddress
                                                  )
                                                    ? _vm._i(
                                                        _vm.contactSameAddress,
                                                        null
                                                      ) > -1
                                                    : _vm.contactSameAddress,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.contactSameAddress,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.contactSameAddress =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.contactSameAddress =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.contactSameAddress =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" 同通訊地址 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Same as mailing address"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請先選擇縣市",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeCity(
                                                    "EmergencyContactCountyGuid"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.baseInfo
                                                    .EmergencyContactCountyGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "EmergencyContactCountyGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.EmergencyContactCountyGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.cityOptions,
                                              function (city) {
                                                return _c("el-option", {
                                                  key: city.Guid,
                                                  attrs: {
                                                    label: city.Name,
                                                    value: city.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 聯絡人地址(區) "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Contact address(District)"
                                                  ),
                                                ]
                                              ),
                                              _c("br"),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.contactSameHousehold,
                                                    expression:
                                                      "contactSameHousehold",
                                                  },
                                                ],
                                                staticStyle: {
                                                  "margin-right": "2px",
                                                },
                                                attrs: {
                                                  type: "checkbox",
                                                  disabled:
                                                    _vm.contactSameAddress,
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.contactSameHousehold
                                                  )
                                                    ? _vm._i(
                                                        _vm.contactSameHousehold,
                                                        null
                                                      ) > -1
                                                    : _vm.contactSameHousehold,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.contactSameHousehold,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.contactSameHousehold =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.contactSameHousehold =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.contactSameHousehold =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" 同戶籍地址 "),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Same as household address"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                placeholder: "請先選擇縣市",
                                              },
                                              model: {
                                                value:
                                                  _vm.baseInfo
                                                    .EmergencyContactDistrictGuid,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.baseInfo,
                                                    "EmergencyContactDistrictGuid",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "baseInfo.EmergencyContactDistrictGuid",
                                              },
                                            },
                                            _vm._l(
                                              _vm.emergencyDistrictOptions,
                                              function (district) {
                                                return _c("el-option", {
                                                  key: district.Guid,
                                                  attrs: {
                                                    label: district.Name,
                                                    value: district.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3 col-sm-12" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              rules:
                                _vm.source === "personnelInformation"
                                  ? "required"
                                  : null,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm.source ===
                                              "personnelInformation"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" 聯絡人地址(村里)"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    "Contact address(Village)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo
                                                    .EmergencyContactVillage,
                                                expression:
                                                  "baseInfo.EmergencyContactVillage",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo
                                                  .EmergencyContactVillage,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "EmergencyContactVillage",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mark" },
                                                [_vm._v("*")]
                                              ),
                                              _vm._v(" 聯絡人地址"),
                                              _c("br"),
                                              _c(
                                                "span",
                                                { staticClass: "en-text" },
                                                [_vm._v("Contact address")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.baseInfo
                                                    .EmergencyContactAddress,
                                                expression:
                                                  "baseInfo.EmergencyContactAddress",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              maxlength: "200",
                                              autocomplete: "off",
                                              readonly: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.baseInfo
                                                  .EmergencyContactAddress,
                                            },
                                            on: {
                                              focus: function ($event) {
                                                return _vm.$common.removeReadonly(
                                                  $event
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.baseInfo,
                                                  "EmergencyContactAddress",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(
                                                " 目前是否在學或計劃於短期繼續升學或進修？ "
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " Are you currently studying or planning to continue further studies in the short term period? "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.baseInfo
                                                      .InSchoolOrHasStudyPlan,
                                                  expression:
                                                    "baseInfo.InSchoolOrHasStudyPlan",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.baseInfo
                                                    .InSchoolOrHasStudyPlan,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "InSchoolOrHasStudyPlan",
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.baseInfo
                                                      .InSchoolOrHasStudyPlan,
                                                  expression:
                                                    "baseInfo.InSchoolOrHasStudyPlan",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.baseInfo
                                                    .InSchoolOrHasStudyPlan,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.baseInfo,
                                                    "InSchoolOrHasStudyPlan",
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm.baseInfo.InSchoolOrHasStudyPlan
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "field-title" }, [
                              _c("span", { style: { color: _vm.fontColor } }, [
                                _vm._v(" 請詳述計畫內容 "),
                                _c("p", { staticClass: "en-text" }, [
                                  _vm._v("Please elaborate plan content"),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "field-value" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.baseInfo.InSchoolOrHasStudyPlanDesc,
                                    expression:
                                      "baseInfo.InSchoolOrHasStudyPlanDesc",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  maxlength: "200",
                                  autocomplete: "off",
                                  readonly: "",
                                },
                                domProps: {
                                  value:
                                    _vm.baseInfo.InSchoolOrHasStudyPlanDesc,
                                },
                                on: {
                                  focus: function ($event) {
                                    return _vm.$common.removeReadonly($event)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.baseInfo,
                                      "InSchoolOrHasStudyPlanDesc",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveBaseInfo)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }